// extracted by mini-css-extract-plugin
export default {"container":"login_container__KW72K","containerHover":"login_containerHover__eVYPx","userDetails":"login_userDetails__Kfuby"};